import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { isEmpty, take } from "lodash";
import { CopyWithInputID } from "../../../../helpers/CopyToClipboard";
import { CopyThisText } from "../../../../helpers/CopyToClipboard";
import { useDispatch, useSelector } from "react-redux";
import {
  showLoadingPage,
  hiddenLoadingPage,
} from "../../../../actions/loadingPage";
import { LoadingPage } from "../../../LoadingPage/LoadingPage";
import { showPrice } from "../../../../utils/priceFunc";
//Services
import {
  usersCreateReferralCodes,
  usersEditReferralCodes,
  usersReferralCodes,
} from "../../../../services/adminServices";
//Styles and Icons
import styles from "./Referral.module.scss";
import CopyIcon2 from "../../../../styles/icon/CopyIcon2.svg";
import closeBtn from "../../../../styles/icon/closeBtnGray.svg";
import ArrowBackIcon from "../../../../styles/icon/arrow_back_fill.svg";
import { errorMessage, successMessage } from "../../../../utils/messages";
//
export default function Referral() {
  const loadingBar = useSelector((state) => state.loadingBar.loading);
  const dispatch = useDispatch();
  const history = useHistory();
  const [referrals, setReferrals] = useState([]);
  const [defaultReferral, setDefaultReferral] = useState("");
  const [lengthOfFriends, setLengthOfFriends] = useState(3);
  const [modalSetting, setModalSetting] = useState({
    visibility: 0,
    pattern: "",
    currentPercent: 0,
    referCode: "",
    isDefault: false,
  });
  //GET Referral Information's
  useEffect(() => {
    let mounted = true;

    if (mounted) {
      (async () => {
        dispatch(showLoadingPage());
        await getUserReferrals();
        dispatch(hiddenLoadingPage());
      })();
    }
    return () => (mounted = false);
  }, []);

  const getUserReferrals = async () => {
    const { data } = await usersReferralCodes();
    if (data) {
      setReferrals(data);
      if (data.referralAccounts) {
        setDefaultReferral(
          data.referralAccounts.filter((ref) => ref.isDefault === true)
        );
      }
    } else {
      errorMessage("مشکلی در دریافت اطلاعات رخ داد");
    }
  };
  //
  const DEFAULT_LINK = "https://arzfi.com/register/refer_code=";
  //
  const profitUserCalculation = (value, friend) => {
    if (!isEmpty(referrals)) {
      let userPercent = referrals.level.percent * 0.01;
      if (!friend) {
        return Math.round(value * userPercent);
      }
    }
  };
  const changeNumber = (e) => {
    if (e.target.value < 0)
      setModalSetting({ ...modalSetting, currentPercent: 0 });
    else if (e.target.value > 100)
      setModalSetting({ ...modalSetting, currentPercent: 100 });
    else setModalSetting({ ...modalSetting, currentPercent: e.target.value });
  };
  //SET DEACTIVATED
  const [deactivatedButton, setDeactivatedButton] = useState(false);
  //Update and Create Code's
  const handleUserReferral = async (e) => {
    e.preventDefault();
    let body = {
      currentPercent: modalSetting.currentPercent,
      isDefault: modalSetting.isDefault,
      referCode: modalSetting.referCode,
    };
    setDeactivatedButton(true);
    if (modalSetting.pattern === "create") {
      const info = await usersCreateReferralCodes(body);
      getUserReferrals();
      setModalSetting({ ...modalSetting, visibility: 0 });
      setDeactivatedButton(false);
      return successMessage(info.data.message);
    } else if (modalSetting.pattern === "edit") {
      const { data } = await usersEditReferralCodes(body);
      if (data) {
        getUserReferrals();
        setModalSetting({ ...modalSetting, visibility: 0 });
        setDeactivatedButton(false);
        return successMessage(data.message);
      } else {
        setDeactivatedButton(false);
        errorMessage("خطایی رخ داد");
      }
    } else {
      setDeactivatedButton(false);
      errorMessage("خطایی رخ داده دوباره تلاش کنید");
    }
  };
  return (
    <>
      {loadingBar && <LoadingPage />}
      <div
        className={`${styles.modal_container} ${
          modalSetting.visibility ? styles.showModal : styles.hiddenModal
        }`}
      >
        <div
          className={styles.bgModal}
          onClick={() => setModalSetting({ visibility: 0, pattern: "" })}
        ></div>
        <div className={styles.modal_view}>
          <div className={styles.modal_close_btn}>
            <img
              src={closeBtn}
              alt="CLOSE"
              width={15}
              height={15}
              onClick={() => setModalSetting({ visibility: 0, pattern: "" })}
            />
          </div>
          <div className={styles.modal_title}>
            {modalSetting.pattern === "create"
              ? "ساخت کد دعوت"
              : "ویرایش کد دعوت"}
          </div>
          <div className={styles.defaultCode_container}>
            <div>کد دعوت پیش فرض شما: </div>
            <div>{referrals?.level?.percent}</div>
          </div>
          <div className={styles.benefits_for_friends}>
            <div>درصد کارمزد دوستان شما از کارمزد شما: </div>
            <div></div>
          </div>
          <form onSubmit={handleUserReferral}>
            <div className={styles.setItem_input}>
              <input
                type="number"
                placeholder="عددی بین 0 تا 100"
                onChange={changeNumber}
                value={modalSetting.currentPercent}
              />
            </div>
            <div className={styles.user_benefits}>
              <div>درصد کارمزد شما: </div>
              <div>
                {profitUserCalculation(100 - modalSetting.currentPercent)}
              </div>
            </div>
            <div className={styles.friends_benefits}>
              <div>درصد کارمزد دوستان: </div>
              <div>{profitUserCalculation(modalSetting.currentPercent)}</div>
            </div>
            <div className={styles.isDefaultLink}>
              <input
                type="checkbox"
                id="isDefaultLink"
                checked={modalSetting.isDefault}
                onChange={(e) =>
                  setModalSetting({
                    ...modalSetting,
                    isDefault: e.target.checked,
                  })
                }
                disabled={deactivatedButton}
              />
              <label htmlFor="isDefaultLink">لینک پیش فرض شود</label>
            </div>
            <div className={styles.btn_submit}>
              <button type="submit" disabled={deactivatedButton}>
                ثبت
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* Top Code For Modal Setting And Style */}
      {/*
       *
       */}
      <div className={styles.container}>
        <div className={styles.back_btn}>
          <img
            src={ArrowBackIcon}
            alt="BACK"
            width={15}
            height={15}
            onClick={() => history.goBack()}
            className="convertPicToWhite"
          />
        </div>
        <div className={`font_color_white ${styles.title_of_page}`}>
          معرفی دوستان
        </div>
        <div className={`font_color_white ${styles.description_page}`}>
          با معرفی دوستان خود و فعالیت آنان در ارزفی{" "}
          {!isEmpty(referrals) && referrals.level.percent} درصد پورسانت بگیرید
        </div>
        <div className={styles.default_code_referral}>
          <input
            type="text"
            readOnly
            disabled
            id="valueOfReferralCode"
            value={
              defaultReferral[0]?.referralCode
                ? defaultReferral[0]?.referralCode
                : referrals?.referralAccounts?.[0].referralCode
            }
          />
          <div onClick={() => CopyWithInputID("valueOfReferralCode")}>
            کپی کد معرفی
          </div>
        </div>
        <div className={styles.default_link_referral}>
          <input
            type="text"
            readOnly
            disabled
            id="valueOfReferralLink"
            value={`${DEFAULT_LINK}${
              defaultReferral[0]?.referralCode
                ? defaultReferral[0]?.referralCode
                : referrals?.referralAccounts?.[0].referralCode
            }`}
          />
          <div onClick={() => CopyWithInputID("valueOfReferralLink")}>
            کپی لینک معرفی
          </div>
        </div>
        <div className={styles.share_container}>
          <div className={styles.share_btn_container}>
            <div>سهم شما: </div>
            <div>
              {profitUserCalculation(defaultReferral[0]?.referrerPercent)}%
            </div>
          </div>
          <div className={styles.share_btn_container}>
            <div>سهم دوستان: </div>
            <div>
              {profitUserCalculation(defaultReferral[0]?.referralPercent)}%
            </div>
          </div>
        </div>
        <div className={`${styles.rules_of_ref_container}`}>
          <Link to="/my-profile/referral-rules">
            <div className="changeBackgroundToGreen font_color_white">
              قوانین طرح پاداش معرفی
            </div>
          </Link>
        </div>

        <div className={styles.list_of_friends}>
          <div className={styles.header_container}>
            <div>لیست دوستان</div>
            <div>پاداش(تومان)</div>
          </div>
          {/*MAP HERE*/}
          {!isEmpty(referrals.users) ? (
            <>
              {take(referrals.users, lengthOfFriends).map((user) => (
                <div className={styles.main_container} key={user.email}>
                  <div className={styles.friend_name}>{user.email}</div>
                  <div className={styles.reward_get}>
                    {showPrice(user.totalPorsant)}
                  </div>
                </div>
              ))}
              {referrals.users.length > 3 &&
              referrals.users.length > lengthOfFriends ? (
                <div
                  className={styles.see_more}
                  onClick={() => setLengthOfFriends(lengthOfFriends + 3)}
                >
                  دیدن موارد بیشتر
                </div>
              ) : (
                <div
                  className={styles.see_more}
                  onClick={() => setLengthOfFriends(3)}
                >
                  بستن موارد بیشتر
                </div>
              )}
            </>
          ) : (
            <div className={styles.main_container}>
              <div className={styles.friend_name}>0</div>
              <div className={styles.reward_get}>0</div>
            </div>
          )}
          {/*MAP HERE*/}
        </div>
        <div className={`${styles.btn_for_create_code_container}`}>
          <div
            className="changeBackgroundToGreen font_color_white"
            onClick={() =>
              setModalSetting({
                ...modalSetting,
                visibility: 1,
                pattern: "create",
                referCode: "",
                currentPercent: 0,
                isDefault: false,
              })
            }
          >
            تولید کد
          </div>
        </div>
        <div className={styles.referrals_code}>
          {!isEmpty(referrals.referralAccounts) &&
            referrals.referralAccounts.map((ref, i) => (
              <div
                className={styles.referral_code_container}
                key={ref.referralCode}
              >
                <div className={styles.referral_number}>
                  <div>کد معرف</div>
                  <div>{i + 1}</div>
                </div>
                <div className={styles.ref_property_container}>
                  <div className={styles.ref_prop_title}>کد معرف</div>
                  <div
                    className={`${styles.ref_prop_value} ${styles.prop_with_copy}`}
                  >
                    <div>{ref.referralCode}</div>
                    <div>
                      <img
                        src={CopyIcon2}
                        alt="CR"
                        width={15}
                        height={15}
                        onClick={() => CopyThisText(ref.referralCode)}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.ref_property_container}>
                  <div className={styles.ref_prop_title}>لینک دعوت</div>
                  <div
                    className={`${styles.ref_prop_value} ${styles.prop_with_copy}`}
                  >
                    <div>{`${DEFAULT_LINK}${ref.referralCode}`}</div>
                    <div>
                      <img
                        src={CopyIcon2}
                        alt="CR"
                        width={15}
                        height={15}
                        onClick={() =>
                          CopyThisText(`${DEFAULT_LINK}${ref.referralCode}`)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.ref_property_container}>
                  <div className={styles.ref_prop_title}>سهم شما</div>
                  <div className={styles.ref_prop_value}>
                    {profitUserCalculation(ref.referrerPercent)}
                  </div>
                </div>
                <div className={styles.ref_property_container}>
                  <div className={styles.ref_prop_title}>سهم دوستان</div>
                  <div className={styles.ref_prop_value}>
                    {profitUserCalculation(ref.referralPercent)}
                  </div>
                </div>
                <div className={styles.ref_property_container}>
                  <div className={styles.ref_prop_title}>تعداد</div>
                  <div className={styles.ref_prop_value}>{ref.totalNumber}</div>
                </div>
                <div className={styles.btn_edit_container}>
                  <div
                    onClick={() =>
                      setModalSetting({
                        ...modalSetting,
                        visibility: 1,
                        pattern: "edit",
                        referCode: ref.referralCode,
                        currentPercent: +ref.referralPercent,
                        isDefault: ref.isDefault,
                      })
                    }
                  >
                    ویرایش
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}
